import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';
import { ChatBotComponent } from '../components/chat-bot/chat-bot.component';

@Injectable({
  providedIn: 'root'
})
export class ChatbotOverlayService {

  private overlayRef!: OverlayRef;

  private chatOpenSubject = new BehaviorSubject<boolean>(false);
  chatOpen$ = this.chatOpenSubject.asObservable();

  constructor(private overlay: Overlay, private injector: Injector) {}

  openChatBot() {

    if (this.overlayRef) {
      return;
    }

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      panelClass: 'chatbot-overlay-panel'
    });

    const portal = new ComponentPortal(ChatBotComponent);
    this.overlayRef.attach(portal);

    this.chatOpenSubject.next(true);
  }

  closeChatBot() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null!;
      this.chatOpenSubject.next(false);
    }
  }
}